import React, { useEffect, useMemo, useRef, useState } from 'react';
import InfiniteScrollColumn from '../../../InfiniteScrollColumn/InfiniteScrollColumn';
import {
  Badge,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormGroup,
  Grow,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Popover,
  Radio,
  Select,
  Typography,
} from '@mui/material';
import zeplinColor from '../../../../../theme/Color';

import ActivityCard from './ActivityCard/ActivityCard';
import CustomAlert from '../../../CustomAlert/CustomAlert';
import CustomPopOver from '../../../CustomPopOver/CustomPopOver';

import CustomButton from '../../../CustomButton/CustomButton';

import { DashboardService } from '../../../../../service/dashboard.service';
import { LightTooltip } from '../../../CustomTooltip/CustomTooltip';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ClientService } from '../../../../../service/client.service';
import style from './ActivityColumn.module.css';
import CardStack from '../../../CardStack/CardStack';
import { SlackService } from '../../../../../service/slack.service';
import { Amplify } from 'aws-amplify';
import { generateClient, GraphQLSubscription } from 'aws-amplify/api';
import config from '../../../../../model/aws-exports';
import { onSlackEvent } from '../../../../../model/graphql/subscriptions';
import { HuddleClientService } from '../../../../../service/huddle-client.service';
import { HuddleDashboardService } from '../../../../../service/huddle-dashboard.service';
import { initialAlertState, useAlertStatus } from '../../../../../customHook/useAlertStatus';
import { renderSlackMessage } from '../../../../featured/Client/ClientSelected/CommunicationTab/helper/renderSlackMessage';
import { useAppDispatch } from '../../../../../store/hooks';
import { showToast } from '../../../../../store/slices/toastSlice';

interface SlackEventResponse {
  data: {
    onSlackEvent: SlackEvent;
  };
}

interface SlackEvent {
  // Define the expected properties of your Slack event
  ts: string;
  text: string;
  user: string;
  type: string;
  // ...other properties
}
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};
Amplify.configure(config as any);
const client = generateClient();

// Slack CHANNEL IDS (the C0... strings), not channel names. The AppSync
// subscription filters on the raw channel ID that Slack sends in event_callback.
// To find an ID: open the channel in Slack web/desktop, View channel details →
// scroll to bottom → "Channel ID".
const CHANNEL_IDS =
  process.env.REACT_APP_ENV === 'prod'
    ? [
        // TODO: replace with prod channel IDs for #general, #deals, #recruiting, #social
      ]
    : [
        'C0971NJP4F9', // huddle-grid-testers
      ];
const ActivityColumn = ({
  setActiveTab,
  setTabLoading,
}: // channelID,
{
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
  // channelID?: string;
}) => {
  const location = useLocation();
  const code = location?.search?.split('code=')[1];
  const redirectPath = sessionStorage.getItem('redirect_path') || '';
  const IsSlackConnected = sessionStorage.getItem('isSlackConnected') === 'true';
  const IsSlackConnecting = sessionStorage.getItem('slackConnecting') === 'true';
  const slackAuthOrigin = sessionStorage.getItem('slackAuthOrigin') || 'activity';

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [applied, setApplied] = useState(false);
  const [selectedItems, setSelectedItems] = useState<{
    time: string[];
    tools: string[];
  }>({
    time: [],
    tools: [],
  });
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<{
    records: any[];
    totalSize: number;
    done: boolean;
    totalFilteredRecords: 0;
  }>({
    records: [],
    totalSize: 0,
    done: true,
    totalFilteredRecords: 0,
  });
  const [newDataTotal, setNewDataTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [showSlackConnect, setShowSlackConnect] = useState(true);
  const [events, setEvents] = useState<any[]>([]);
  const [slackMessage, setSlackMessage] = useState<any[]>([]);
  const [slackChannel, setSlackChannel] = useState('');
  const [unauthorized, setUnauthorized] = useState(false);
  const { alertState, completeOperation, setAlertState, getAlertContent } = useAlertStatus();
  // const [channelID, setChannelID] = useState<string | null>(null);
  const normalizeSlackMessage = (message: any) => ({
    ...message,
    text: renderSlackMessage(message),
    replies: Array.isArray(message?.replies)
      ? message.replies.map((reply: any) => ({
          ...reply,
          text: renderSlackMessage(reply),
        }))
      : message?.replies,
  });

  const toSlackEventPayload = (event: any) =>
    normalizeSlackMessage({
      ...event,
      userDetails: { name: event?.user, image: event?.userImage },
    });

  const slackMessageRef = useRef(slackMessage);
  useEffect(() => {
    slackMessageRef.current = slackMessage;
  }, [slackMessage]);
  useEffect(() => {
    // Create the subscription
    const subscription = IsSlackConnected
      ? CHANNEL_IDS.map((id) =>
          client
            .graphql<GraphQLSubscription<typeof onSlackEvent>>({
              query: onSlackEvent,
              variables: { channelId: id },
              authMode: 'apiKey' as const,
            })
            .subscribe({
              next: (response) => {
                // The response type is GraphqlSubscriptionMessage<GraphQLSubscription<typeof onSlackEvent>>
                const event = (response.data as any)?.onSlackEvent;
                if (!event || event?.channelId !== id || event?.eventType === 'reaction_added')
                  return;
                if (event) {
                  console.log('Received event:', event);
                  const match = slackMessageRef.current?.find((msg) =>
                    msg?.thread_ts
                      ? msg?.thread_ts === event?.thread_ts
                      : msg?.ts === event?.thread_ts,
                  );

                  if (event?.parentText && event?.parentTS && event?.eventType === 'message') {
                    // We're dealing with a reply in a thread
                    // Find the parent message and update the specific reply
                    const newThread = {
                      ...event,
                      text: renderSlackMessage({ text: event?.parentText }), // Use parent text for the parent message
                      // ts: event?.ts, // Use parent timestamp
                      ts: event?.parentTS ? event?.parentTS : event?.ts, // Use parent timestamp
                      ...(event?.parentTS && {
                        replies: [
                          {
                            text: renderSlackMessage(event), // Update the reply text
                            ts: event?.ts, // Update the reply timestamp

                            userDetails: {
                              name: event?.user,
                              image: event?.userImage,
                            },
                          },
                        ],
                      }),
                      userDetails: {
                        name: event?.parentUserName,
                        image: event?.parentUserImage,
                      },
                    };
                    // Update events array
                    setEvents((prev) => [
                      ...prev.filter((msg) => msg?.ts !== event?.parentTS),
                      newThread,
                    ]);

                    // Move the updated parent thread to the top of the list
                    setSlackMessage((prev) => [
                      ...(slackMessageRef.current.filter((msg) =>
                        msg?.thread_ts
                          ? msg?.thread_ts === event?.thread_ts
                          : msg?.ts === event?.thread_ts,
                      )?.length
                        ? slackMessageRef.current
                            ?.filter((msg) =>
                              msg?.thread_ts
                                ? msg?.thread_ts === event?.thread_ts
                                : msg?.ts === event?.thread_ts,
                            )
                            ?.map((msgReturn: any) => ({
                              ...msgReturn,
                              replies: [
                                ...(msgReturn?.replies?.length ? msgReturn?.replies : []),
                                {
                                  text: renderSlackMessage(event),
                                  ts: event?.ts,
                                  userDetails: { name: event?.user, image: event?.userImage },
                                },
                              ],
                            }))
                        : [newThread]),
                      ...slackMessageRef.current?.filter((msg) =>
                        msg?.thread_ts
                          ? msg?.thread_ts !== event?.thread_ts
                          : msg?.ts !== event?.thread_ts,
                      ),
                    ]);
                  } else if (event?.eventType === 'message deleted') {
                    if (event?.thread_ts) {
                      const filterMatch = slackMessageRef.current.filter((msg) =>
                        msg?.thread_ts
                          ? msg?.thread_ts === event?.thread_ts
                          : msg?.ts === event?.thread_ts,
                      );
                      if (filterMatch?.length) {
                        setSlackMessage((prev) => {
                          // Find the thread's current position in the array
                          const threadPositions = prev.map((msg, index) => ({
                            msg,
                            index,
                            isMatch: msg?.thread_ts
                              ? msg?.thread_ts === event?.thread_ts
                              : msg?.ts === event?.thread_ts,
                          }));

                          // Create a new array with the same ordering
                          const newArray = [...prev];

                          // Update each thread that matches
                          threadPositions
                            .filter((item) => item.isMatch)
                            .forEach(({ index }) => {
                              // Replace the thread at its current position with the updated version
                              newArray[index] = {
                                ...prev[index],
                                replies: prev[index]?.replies?.filter(
                                  (reply: any) => reply?.ts !== event?.ts,
                                ),
                              };
                            });

                          return newArray;
                        });
                      }
                    } else {
                      const parsedEventText = renderSlackMessage(event);
                      setSlackMessage((prev) =>
                        prev?.filter((msg) => msg.text !== parsedEventText),
                      );
                      setEvents((prev) => [...prev?.filter((msg) => msg.text !== parsedEventText)]);
                    }
                  } else if (event?.eventType === 'edited message') {
                    if (event?.originalText && event?.text === event?.originalText) {
                      return;
                    }

                    const parsedOriginalText = renderSlackMessage({ text: event?.originalText });

                    if (event?.thread_ts) {
                      // Find all messages in the thread
                      const foundThreadMessages = slackMessageRef.current.filter((msg) =>
                        msg?.thread_ts
                          ? msg?.thread_ts === event?.thread_ts
                          : msg?.ts === event?.thread_ts,
                      );

                      // Map them to updated versions
                      const updatedThreadMessages = foundThreadMessages.map((threadMsg) => {
                        // Case 1: This is the parent message being edited
                        if (threadMsg.text === parsedOriginalText || threadMsg?.ts === event?.ts) {
                          return {
                            ...threadMsg,
                            ...event,
                            text: renderSlackMessage(event),
                            ts: event?.ts,
                            isEdited: true,
                            // Preserve the original replies array
                            replies: threadMsg.replies || [],
                          };
                        }
                        // Case 2: This is a parent with a reply being edited
                        else {
                          return {
                            ...threadMsg,
                            // Map through replies to find and update the edited one
                            replies: threadMsg?.replies?.map((reply: any) =>
                              reply?.text === parsedOriginalText || reply?.ts === event?.ts
                                ? {
                                    ...reply,
                                    ...event,
                                    text: renderSlackMessage(event),
                                    ts: event?.ts,
                                    isEdited: true,
                                  }
                                : reply,
                            ),
                          };
                        }
                      });

                      // Update the events array with the new thread messages
                      setEvents((prev) => [
                        ...updatedThreadMessages,
                        ...prev.filter(
                          (msg) =>
                            msg?.thread_ts !== event?.thread_ts && msg?.ts !== event?.thread_ts,
                        ),
                      ]);

                      // Update the slackMessage array with the new thread messages
                      setSlackMessage((prev) => [
                        ...updatedThreadMessages,
                        ...prev.filter(
                          (msg) =>
                            msg?.thread_ts !== event?.thread_ts && msg?.ts !== event?.thread_ts,
                        ),
                      ]);
                    } else {
                      const foundMsg = slackMessageRef.current
                        .filter(
                          (msgFilter) =>
                            msgFilter?.ts === event?.ts ||
                            msgFilter?.text === renderSlackMessage({ text: event?.originalText }),
                        )
                        .map((msg) => ({
                          ...msg,
                          text: renderSlackMessage(event),
                          ts: event?.ts,
                          isEdited: true,
                        }));
                      if (foundMsg?.length) {
                        setEvents((prev) => [
                          ...prev.filter((msg) => msg?.ts !== event?.ts),
                          ...slackMessageRef.current
                            .filter(
                              (msg) => msg?.ts === event?.ts || msg?.text === parsedOriginalText,
                            )
                            .map((msgReturn: any) => {
                              return {
                                ...msgReturn,
                                text: renderSlackMessage(event),
                                ts: event?.ts,
                              };
                            }),
                        ]);
                        // Update slackMessage state, bringing edited messages to the top
                        setSlackMessage((prev) => [
                          ...foundMsg,
                          ...prev.filter((msg) => msg?.ts !== event?.ts),
                        ]);
                        // This will log the messages that were edited
                        // later add comparison of msg?.ts === event?.originalTs...next to wherever originalText is being compared.
                      } else {
                        setEvents((prev) => [
                          ...prev.filter((msg) => msg?.ts !== event?.ts),
                          {
                            ...event,
                            text: renderSlackMessage(event),
                            ts: event?.ts,

                            userDetails: { name: event?.user, image: event?.userImage },
                          },
                        ]);
                        setSlackMessage((prev) => [
                          toSlackEventPayload(event),
                          ...prev.filter((msg) => msg?.ts !== event?.ts),
                        ]);
                      }
                    }
                  } else {
                    setSlackMessage((prev) => [toSlackEventPayload(event), ...prev]);
                    setEvents((prev) => [toSlackEventPayload(event), ...prev]);
                  }
                  // setEvents((prev: SlackEvent[]) => [event, ...prev]);
                }
              },
              error: (error: Error) => {
                console.error('Subscription error:', error);
                completeOperation('fetch', 'Failed to receive Slack updates', true);
              },
            }),
        )
      : undefined;

    return () => subscription?.forEach((sub) => sub.unsubscribe());
  }, [IsSlackConnected]);

  const getSlackMessage = async (channelId: string) => {
    try {
      const res = await SlackService.getSlackChannelMessages(channelId);
      console.log({ res });
      // setSlackChannel(res?.channelName);
      const messagesWithChannel =
        res?.messages?.map((message: any) => ({
          ...normalizeSlackMessage(message),
          channelId: channelId, // Store the channel ID
          channel: res?.channelName, // Store the channel name
        })) || [];
      setSlackMessage((prev) => [...prev, ...messagesWithChannel]);
    } catch (err) {
      console.error('Error fetching Slack message:', err);
      completeOperation('fetch', 'Failed to fetch Slack messages', true);
      // if (err?.response?.status === 401 || err?.status === 401) {
      // Reset Slack connection state
      sessionStorage.setItem('isSlackConnected', 'false');
      sessionStorage.removeItem('slackConnecting');
      sessionStorage.setItem('slackUnauthorized', 'true');
      // Clear Slack data
      setSlackMessage([]);
      setSlackChannel('');
      setEvents([]);

      setUnauthorized(true);
    }
  };

  const getSlackToken = async () => {
    try {
      console.log('Attempting to fetch Slack token with code:', code || 'NA');
      if (code) {
        setLoading(true);
        const res = await SlackService.getSlackLogin(code.replace('&state=', ''));

        if (res?.ok) {
          window.dispatchEvent(
            new CustomEvent('sessionStorageChange', {
              detail: { key: 'isSlackConnected', value: 'true' },
            }),
          );
          setShowSlackConnect(false);
          sessionStorage.setItem('isSlackConnected', 'true');
          sessionStorage.removeItem('slackAuthOrigin');
          dispatch(showToast({ message: 'Slack connected successfully' }));
          completeOperation('fetch', 'Slack connected successfully', false);
          // Navigate back to the originating client page
          const returnPath = sessionStorage.getItem('redirect_path');
          const targetPath = returnPath || location.pathname;
          if (returnPath) {
            sessionStorage.removeItem('redirect_path');
            sessionStorage.removeItem('sf_redirect');
            sessionStorage.removeItem('slackConnecting');
          }
          navigate(targetPath, { replace: true });
          return;
        }
        setLoading(false);
      }
    } catch (err) {
      completeOperation('fetch', 'Failed to connect Slack account', true);
      dispatch(showToast({ message: 'Failed to connect Slack account', error: true }));
    }
  };

  const getTimestampFromSlackMessage = (msg: any): number => {
    if (msg?.ts) {
      // Slack timestamps are in format "1234567890.123456"
      return parseInt(msg.ts.split('.')[0]) * 1000;
    }
    return 0;
  };

  const getTimestampFromSFRecord = (record: any): number => {
    if (record?.date) {
      return new Date(record.date).getTime();
    }
    if (record?.LastModifiedDate) {
      return new Date(record.LastModifiedDate).getTime();
    }
    return 0;
  };

  // Function to merge and sort activities chronologically
  const getMergedActivities = (sfRecords: any[], slackMessages: any[]) => {
    // Transform SF/Huddle records to include timestamp and type based on SOURCE
    const transformedSFRecords = sfRecords.map((record, index) => ({
      ...record,
      timestamp: getTimestampFromSFRecord(record),

      activityType: record.source === 'HUDDLE' ? 'huddle' : 'salesforce',
      originalIndex: index,
    }));

    // Transform Slack messages to include timestamp and type
    const transformedSlackMessages = slackMessages.map((msg, index) => ({
      ...msg,
      timestamp: getTimestampFromSlackMessage(msg),
      activityType: 'slack',
      originalIndex: index,
    }));

    // Merge both arrays
    const allActivities = [...transformedSFRecords, ...transformedSlackMessages];

    // Sort by timestamp (most recent first)
    return allActivities.sort((a, b) => b.timestamp - a.timestamp);
  };

  const getActivity = async (next?: boolean, init?: boolean) => {
    setLoading(true);
    try {
      const toolsQuery = selectedItems.tools.join(',');
      const timeQuery = selectedItems.time
        .map((val: string) => (val === 'Day' ? 'today' : 'this' + val.toLocaleLowerCase()))
        .join(',');

      const requestOffset = next ? offset + 10 : 0;

      // Common payload structure
      const commonPayload = {
        limit: 10,
        timeRange: timeQuery,
        tools: toolsQuery,
        offset: requestOffset,
      };

      let primaryRequestPromise;
      let huddleRequestPromise: any = Promise.resolve(null); // Default to a resolved promise with null

      // --- 1. Define Request Promises ---
      if (params?.id) {
        // Case A: Client/Team view (params?.id exists)
        if (location?.pathname?.includes('huddle')) {
          primaryRequestPromise = HuddleClientService.getHuddleActivity(params.id, commonPayload);
        }
        // else {
        //   primaryRequestPromise = ClientService.getActivity(params.id, commonPayload);
        // }
      } else {
        // Case B: Dashboard view (params?.id is NOT set)
        // primaryRequestPromise = DashboardService.getActivity(commonPayload);

        // CALL HUDDLE API IN PARALLEL ONLY ON THE DASHBOARD
        huddleRequestPromise = HuddleDashboardService.getHuddleActivity(commonPayload);
      }

      // --- 2. Execute Requests in Parallel ---
      const [resPrimary, resHuddle] = await Promise.all([
        primaryRequestPromise,
        huddleRequestPromise,
      ]);

      // --- 3. Merge Data (If Huddle was called) ---
      // If resHuddle is null (when not on dashboard), this is safe.
      const primaryActivity = resPrimary?.lastActivity || resPrimary; // Handle structure variation
      const huddleActivity = resHuddle?.lastActivity || resHuddle;

      let finalRecords = (primaryActivity?.records || []).map((record: any) => ({
        ...record,
        source: location?.pathname?.includes('huddle') ? 'HUDDLE' : 'SALESFORCE', // or 'PRIMARY', 'CRM', etc.
      }));

      let finalTotal = primaryActivity?.totalSize || 0;

      if (huddleActivity) {
        // We are in the dashboard and need to combine data
        finalRecords = [
          ...finalRecords,
          ...(huddleActivity.records || []).map((record: any) => ({
            ...record,
            source: 'HUDDLE', // or 'PRIMARY', 'CRM', etc.
          })),
        ];
        finalRecords.sort((a: any, b: any) => {
          // 1. Parse dates safely.
          // If date is missing/null, default to 0.
          // If date string is invalid text, getTime() returns NaN.
          const dateA = a.date ? new Date(a.date).getTime() : 0;
          const dateB = b.date ? new Date(b.date).getTime() : 0;

          // 2. Handle invalid dates (NaN) explicitly
          // If the date string was "invalid", treat it as 0 (oldest)
          const validA = isNaN(dateA) ? 0 : dateA;
          const validB = isNaN(dateB) ? 0 : dateB;

          // 3. Sort Descending (Newest first)
          return validB - validA;
        });
        finalTotal = finalTotal + (huddleActivity.totalSize || 0);
      }

      // Create the merged response object
      const mergedResponse = {
        ...primaryActivity, // Use primary response as the base for metadata
        records: finalRecords,
        totalSize: finalTotal,
      };

      // --- 4. Update Offset and State ---

      // Logic from original function (using merged total for comparison)
      if (!init && !timeQuery && !toolsQuery && !next) {
        setNewDataTotal(mergedResponse.totalSize - data?.totalSize);
      }

      if (next) {
        setOffset((prev) => prev + 10);
      } else {
        setOffset(0);
      }

      if (mergedResponse) {
        if (!next) {
          // Initial load or filter change
          setData(mergedResponse);
        } else {
          // Pagination: Append new records
          setData((prev) => ({
            ...mergedResponse, // Update total size and metadata
            records: [...prev.records, ...mergedResponse.records],
          }));
        }
      }
    } catch (err) {
      completeOperation('fetch', 'Failed to fetch activities', true);
    } finally {
      setLoading(false);
      setTabLoading(false);
    }
  };
  // console.log(data);
  const getAllClient = async (refresh = false, tokenInit = false) => {
    setLoading(true);
    try {
      const storedPath = sessionStorage.getItem('redirect_path') || '';
      const isSlackOAuthReturn = sessionStorage.getItem('slackConnecting') === 'true';
      // During Slack OAuth return we are always on /dashboard but storedPath is the client route.
      // Skip the path equality check so getAllClient still runs to load channels.
      const pathCondition = isSlackOAuthReturn
        ? true
        : (storedPath && location?.pathname === storedPath) || !storedPath;

      if (pathCondition) {
        // const res = location?.pathname?.includes('huddle')
        //   ? await HuddleClientService.getAllClient()
        //   : await ClientService.getAllClient();
        const res = await HuddleClientService.getAllClient();
        // const storedPath = sessionStorage.getItem('redirect_path') || '';
        const currentAccountId = location.pathname.split('/').pop();

        if (currentAccountId && res?.clients) {
          const filteredClient = res.clients.filter(
            (client: any) =>
              client.AccountId === currentAccountId || client.Id === currentAccountId,
          );

          if (IsSlackConnected || tokenInit) {
            refresh && setSlackMessage([]);
            if (filteredClient.length > 0) {
              if (filteredClient[0]?.slackChannelId) {
                // getSlackMessage(filteredClient[0]?.slackChannelId?.split(',')[0]);
                filteredClient[0]?.slackChannelId?.split(',')?.map((val: string) => {
                  getSlackMessage(val);
                });
              }
            } else if (location?.pathname?.includes('dashboard')) {
              if (process.env.REACT_APP_ENV === 'prod') {
                await getSlackMessage('C01G3ALUCG2');
                await getSlackMessage('C055KKGL09J');
                await getSlackMessage('C088KR2JJJ0');
                await getSlackMessage('C01FX2DETT8');
              } else {
                await getSlackMessage('C0971NJP4F9');
                await getSlackMessage('C09AS1U38L8');
              }
            }
          }
        }
        sessionStorage.removeItem('sf_redirect');
        sessionStorage.removeItem('redirect_path');
        sessionStorage.removeItem('slackConnecting');
      }
    } catch (err: any) {
      completeOperation('fetch', 'Failed to fetch client channels', true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!IsSlackConnected && redirectPath) {
        IsSlackConnecting && slackAuthOrigin !== 'communication' && getSlackToken();
      }
      IsSlackConnected && getAllClient(true, true);
      setLoading(false);
    };
    fetchData();
    getActivity(false, true);
    sessionStorage.removeItem('slackUnauthorized');
  }, [IsSlackConnected]);

  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleClearAll = () => {
    setSelectedItems({
      time: [],
      tools: [],
    });
    getActivity(false, true);
    setAnchorEl(null);
    setApplied(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMarkRead = () => {
    setNewDataTotal(0);
    setEvents([]);
  };
  const applyFilter = () => {
    getActivity();
    setAnchorEl(null);
    setApplied(true);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  // let slackDone = false;
  const renderActivityCard = (valRender: any, index: number, mergedActivities: any[]) => {
    if (valRender?.activityType === 'slack') {
      // Skip subtype messages (like join/leave notifications)
      if (valRender?.subtype) return null;

      // Create an array of messages for this thread
      const messages = [];

      // Add the parent message first
      messages.push({
        ...valRender,
        channel: valRender?.channel || slackChannel,
        new:
          events?.filter((event) => event?.ts === valRender?.ts && event?.text === valRender?.text)
            ?.length > 0,
        id: `slack_${valRender?.user}_${valRender?.ts}`,
        isSlack: true,
        sender: valRender?.userDetails?.name,
        sender_img: valRender?.userDetails?.image,
        account: valRender?.text,
        date: valRender?.ts ? new Date(parseInt(valRender?.ts.split('.')[0]) * 1000) : new Date(),
      });

      // Add replies if they exist, starting from index 1
      if (
        valRender?.replies &&
        Array.isArray(valRender?.replies) &&
        valRender?.replies?.length > 0
      ) {
        for (let i = 0; i < valRender?.replies.length; i++) {
          const reply = valRender?.replies[i];
          messages.push({
            ...reply,
            id: `slack_reply_${reply?.user}_${reply?.ts}`,
            // channel: val?.channel || slackChannel,
            new:
              events?.filter(
                (event) => event?.ts === valRender?.ts && event?.text === valRender?.text,
              )?.length > 0,
            isSlack: true,
            isReply: true,
            parentMessage: valRender?.text,
            sender: reply?.userDetails?.name,
            sender_img: reply?.userDetails?.image,
            account: reply?.text,
            date: reply?.ts ? new Date(parseInt(reply?.ts.split('.')[0]) * 1000) : new Date(),
          });
        }
      }

      return (
        <Box
          key={`stack_${valRender.user}_${valRender.ts}`}
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            position: 'relative',
          }}
        >
          <CardStack
            cards={messages}
            readOnly={true}
            renderCard={(card, isExpanded, isLast, isFirst, total, handleCardClick) => (
              <ActivityCard
                val={card}
                newData={newDataTotal}
                index={0}
                loading={false}
                isExpanded={isExpanded}
                isFirstCard={isFirst}
                total={total}
                handleCardClick={handleCardClick}
              />
            )}
          />
        </Box>
      );
    }
    return (
      <ActivityCard
        val={valRender}
        newData={newDataTotal}
        index={index}
        loading={loading}
        key={index}
      />
    );
  };

  const Column = () => {
    const mergedActivities = useMemo(() => {
      // 1. Merge ALL available data first
      const allActivity = getMergedActivities(data?.records || [], slackMessage || []);

      // 2. Apply Strict Filtering
      return allActivity.filter((item) => {
        // If not applied, show everything
        if (!applied) return true;

        if (selectedItems.tools.length === 0) return true;

        // Strict Tool Checks

        if (item.activityType === 'huddle') return selectedItems.tools.includes('Huddle');
        if (item.activityType === 'slack') return selectedItems.tools.includes('Slack');

        return true;
      });
    }, [data?.records, slackMessage, applied, selectedItems.tools]);

    return (
      <>
        {loading ? (
          <Box
            className={style.activityColumn}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height:
                !IsSlackConnected && showSlackConnect
                  ? { xs: 'calc(100vh - 570px)', xl: 'calc(100vh - 760px)' }
                  : { xs: 'calc(100vh - 560px)', xl: 'calc(100vh - 750px)' },
              overflow: 'hidden',
            }}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val: any, index: number) => (
              <ActivityCard val={val} newData={0} index={index} loading={true} key={index} />
            ))}
          </Box>
        ) : mergedActivities.length === 0 && !loading ? (
          <>
            {!IsSlackConnected &&
              showSlackConnect &&
              !location?.pathname?.includes('team') &&
              !loading && (
                <ActivityCard
                  val={0}
                  newData={0}
                  index={0}
                  loading={false}
                  slackConnectBtn={true}
                  setShowSlackConnect={setShowSlackConnect}
                />
              )}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height:
                  !IsSlackConnected && showSlackConnect
                    ? { xs: 'calc(100vh - 570px)', xl: 'calc(100vh - 760px)' }
                    : { xs: 'calc(100vh - 560px)', xl: 'calc(100vh - 750px)' },
              }}
            >
              {' '}
              <img src={'/assets/no-activity.svg'} className={style['no-activity-icon']} />
              <Typography
                variant='responsiveHeading3'
                color={zeplinColor.BasicBlack}
                sx={{ marginTop: { xs: '22px', xl: '24px' } }}
              >
                No Activity Found
              </Typography>
              <Typography
                variant='responsiveBody3'
                color={zeplinColor.Neutral8}
                sx={{ marginTop: { xs: '10px', xl: '12px' } }}
              >
                When there's something new, you'll see it here.
              </Typography>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height:
                !IsSlackConnected && showSlackConnect
                  ? { xs: 'calc(100vh - 570px)', xl: 'calc(100vh - 760px)' }
                  : { xs: 'calc(100vh - 560px)', xl: 'calc(100vh - 750px)' },
              overflow: 'auto',
            }}
          >
            <Box
              className={style.activityColumn}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: 1,
                width: '100%',
                overflowY: 'auto',
              }}
            >
              {!IsSlackConnected && showSlackConnect && !location?.pathname?.includes('team') && (
                <ActivityCard
                  val={0}
                  newData={0}
                  index={0}
                  loading={false}
                  slackConnectBtn={true}
                  setShowSlackConnect={setShowSlackConnect}
                />
              )}

              {/*Render the strictly filtered merged list */}
              {mergedActivities.map((activity, index) =>
                renderActivityCard(activity, index, mergedActivities),
              )}

              {data?.records?.length ? (
                <CustomButton
                  disabled={false}
                  onClick={() => {
                    setActiveTab(1);
                  }}
                  variant='outlined'
                  color='secondary'
                  style={{
                    borderRadius: 50,
                    height: 32,
                    textAlign: 'center',
                    gap: '16px',
                  }}
                  textStyle={{ color: zeplinColor.BasicBlack }}
                  text={'See All'}
                  icon={''}
                  buttonVariant='buttonSmall'
                />
              ) : (
                ''
              )}
            </Box>
          </Box>
        )}
      </>
    );
  };

  const Tools = ['Huddle', 'Slack'];
  const TimeRange = ['Day', 'Week', 'Month'];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        flex: 1,
        padding: '16px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        borderRadius: '14px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relatives',
          padding: '10px 0px 0px 0px',
        }}
      >
        <Typography variant='responsiveHeading3'>Recent Activity</Typography>
        <Box
          sx={{
            display: 'flex',
            // justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relatives',
            gap: '8px',
          }}
        >
          <LightTooltip
            title={
              <Typography variant='body3' color={zeplinColor.Neutral1}>
                Refresh
              </Typography>
            }
            placement='bottom-end'
            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
            // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
          >
            <Box
              className={style.refreshActivity}
              sx={{
                border: `1px solid ${zeplinColor.Neutral6}`,
                // p: '0px 10px',
                backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Neutral1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: zeplinColor.Neutral4,
                  // border: `1px solid ${zeplinColor.BasicBlack}`,
                },
              }}
              onClick={
                loading
                  ? () => {}
                  : async () => {
                      getActivity();
                      if (IsSlackConnected) {
                        setLoading(true);
                        await getAllClient(true);
                        setLoading(false);
                      }
                      setEvents([]);
                    }
              }
            >
              <img
                src={'/assets/refresh.svg'}
                alt='refresh-activity'
                id='refresh-activity'
                className={style.icon}
              />
            </Box>
          </LightTooltip>
          <LightTooltip
            title={
              <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                Mark all as read
              </Typography>
            }
            placement='bottom-end'
            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
            // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
          >
            <Box
              className={style.refreshActivity}
              sx={{
                border: `1px solid ${zeplinColor.Neutral6}`,
                // p: '0px 10px',
                backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Neutral1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: zeplinColor.Neutral4,
                  // border: `1px solid ${zeplinColor.BasicBlack}`,
                },
              }}
              onClick={() => (loading ? '' : handleMarkRead())}
            >
              <img
                src={'/assets/done_all.svg'}
                alt='mark-read-activity'
                id='mark-read-activity'
                className={style.icon}
              />
            </Box>
          </LightTooltip>
          <Badge
            badgeContent={Object.values(selectedItems).reduce(
              (prev, val) => (val?.length ? prev + 1 : prev),
              0,
            )}
            color='primary'
            sx={{
              '.MuiBadge-badge': {
                top: { xs: '0.5', xl: '0.7rem' },
                right: '0.2rem',
                zIndex: 99,
                fontSize: { xs: '10px', xl: '12px' },
              },
            }}
          >
            <LightTooltip
              title={
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                  Filter
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box
                className={style.refreshActivity}
                sx={{
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  // p: '0px 10px',
                  backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Neutral1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: zeplinColor.Neutral4,
                    // border: `1px solid ${zeplinColor.BasicBlack}`,
                  },
                }}
                onClick={(e) => (loading ? '' : handleClick(e))}
              >
                <img
                  src={'/assets/filter.svg'}
                  alt='filter-activity'
                  id='filter-activity'
                  className={style.icon}
                />
              </Box>
            </LightTooltip>
          </Badge>
        </Box>
        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '1rem',
            marginRight: '2rem',
            marginLeft: '-4rem',
          }}
        >
          <Box
            sx={{
              padding: '16px',
              width: { xs: '230px', xl: '283px' },
              height: '286px',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Filter
              </Typography>
              <Typography
                variant='responsiveButtonSmall'
                color={
                  Object.values(selectedItems).every((val) => val.length <= 0)
                    ? zeplinColor.Neutral8
                    : zeplinColor.Brand1
                }
                onClick={
                  Object.values(selectedItems).every((val) => val.length <= 0)
                    ? () => {}
                    : handleClearAll
                }
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              >
                Clear All
              </Typography>
            </Box>
            <FormGroup
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' }, // Responsive font size
                    // lineHeight: { xs: '16px', sm: '18px', md: '20px', xl: '24px' }, // Responsive line height
                    fontWeight: 400, // Consistent font weight
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Tools
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.tools}
                  onChange={(e) => handleSelection(e, 'tools')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px',
                      }}
                      label='tools'
                    />
                  }
                  renderValue={(selected) => (selected as string[]).join(', ')}
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                  )}
                >
                  {Tools.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{
                        fontSize: { xs: '14px', xl: '16px' }, // Match responsive font size
                        padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                      }}
                    >
                      <Checkbox
                        checked={selectedItems.tools.indexOf(name) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' }, // Responsive font size
                    // lineHeight: { xs: '16px', sm: '18px', md: '20px', xl: '24px' }, // Responsive line height
                    fontWeight: 400, // Consistent font weight
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Time range
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  value={selectedItems.time}
                  onChange={(e) => handleSelection(e, 'time')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px',
                      }}
                      label='Time range'
                    />
                  }
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                  )}
                  renderValue={(selected) => selected[0]}
                  MenuProps={MenuProps}
                >
                  {TimeRange.map((name) => (
                    <MenuItem key={name} value={name} sx={{ fontSize: { xs: '14px', xl: '16px' } }}>
                      <Radio
                        checked={selectedItems.time[0] === name} // Check if this radio should be selected
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '& .MuiSvgIcon-root': {
                            fontSize: { xs: '18px', xl: '20px' },
                          },
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                <CustomButton
                  onClick={applyFilter}
                  variant='contained'
                  disabled={Object.values(selectedItems).every((val) => val.length <= 0)}
                  color={'primary'}
                  style={{ width: '100%', borderRadius: '14px', height: { xs: 48, xl: 56 } }}
                  textStyle={{
                    color: Object.values(selectedItems).every((val) => val.length <= 0)
                      ? zeplinColor.Neutral8
                      : zeplinColor.Neutral1,
                    fontSize: { xs: '14px', xl: '16px' },
                  }}
                  text={'Apply'}
                />
              </Box>
            </FormGroup>
          </Box>
        </CustomPopOver>
      </Box>
      {newDataTotal + events?.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Chip
            label={
              <Typography variant='label1' color={zeplinColor.BasicBlack}>
                {newDataTotal + events?.length} new{' '}
                {newDataTotal + events?.length > 1 ? 'activities' : 'activity'}
              </Typography>
            }
            sx={{
              backgroundColor: zeplinColor.Neutral3,
              padding: '5px 12px 5px 12px',
              borderRadius: '18px',
            }}
          />
        </Box>
      )}
      <Column />

      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </Box>
  );
};

export default ActivityColumn;
